import MetaTable from '../objects/MetaTable';

class TableXMLParser {
    constructor(datasetXMLDocument) {
        this.datasetXMLDocument = datasetXMLDocument;
    }

    _parseTable(tableNode) {
        const table = new MetaTable();

        table.guid = tableNode.getAttribute('GUID');
        table.variableCount = parseInt(tableNode.getAttribute('VariableCount'), 10);
        table.datasetAbbreviation = tableNode.getAttribute('DatasetAbbreviation');
        table.name = tableNode.getAttribute('Name');

        return table;
    }

    _parseTables(datasetXMLDocument) {
        const tables = [];
        const tableNodes = datasetXMLDocument.getElementsByTagName('Table');

        for (let i = 0; i < tableNodes.length; i += 1) {
            const tableNode = tableNodes[i];
            tables.push(this._parseTable(tableNode));
        }
        return tables;
    }

    tables() {
        return this._parseTables(this.datasetXMLDocument);
    }
}

export default TableXMLParser;
